export default "__VITE_ASSET__B5zqYbC2__"